import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MapsService } from './service/maps.service';

export function provideMaps(): EnvironmentProviders {
  return makeEnvironmentProviders([MapsService]);
}
